import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isPathAllowedByMeta } from '../utils/utils';

/** Blocks routes that are hidden from the sidebar for the current meta. */
const GuardedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isPathAllowedByMeta(props.location.pathname) ? (
        <Component {...props} />
      ) : (
        <Redirect to="/overview" />
      )
    }
  />
);

export default GuardedRoute;
